import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";
import {setCookie} from "../../utils/cookie";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ResetResult {
    data: any[];
}

export const respondToConsumer = createAsyncThunk(
    'quote/respond',
    async (params: any, { rejectWithValue }) => {

        // sellsmart-api#4756: the link token goes in the JSON body as `token`, never in the URL.
        // `token` is spread last, so a stray `token` key in params.data cannot replace it.
        const resendURL = `${URL_API}/supplier-portal/quote-request-forms/notification`;

        try {
            const { data } = await axios.post<ResetResult>(resendURL, { ...params.data, token: params.token }, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
            });

            return data;
        } catch (error) {
            // @ts-ignore
            return rejectWithValue(error.response.data)
        }
    }
);